// plugins/questback.client.ts
import { defineNuxtPlugin } from '#app'
import { QUESTBACK_POPUP_URL, questbackPopupConfig } from '~/utils/questback-config'
import { useUserStore } from '~/stores/user'

declare global {
    interface Window {
        questback?: any
    }
}

function loadQuestbackScript(src: string) {
    return new Promise<void>((resolve, reject) => {
        if (window.questback?.popup) return resolve()

        const existing = document.querySelector<HTMLScriptElement>('script[data-questback-popup="1"]')
        if (existing) {
            existing.addEventListener('load', () => resolve(), { once: true })
            existing.addEventListener('error', () => reject(new Error('Questback script failed to load')), { once: true })
            return
        }

        const script = document.createElement('script')
        script.src = src
        script.async = true
        script.dataset.questbackPopup = '1'
        script.addEventListener('load', () => resolve(), { once: true })
        script.addEventListener('error', () => reject(new Error('Questback script failed to load')), { once: true })
        document.head.appendChild(script)
    })
}


export default defineNuxtPlugin(async (nuxtApp) => {
    if(!nuxtApp.$config.public.features.questbackSurvey) return;

    const userStore = useUserStore()
    try {
        await userStore.checkLogin(false)
    } catch (e) {
        return;
    }

    if (!userStore.isLoggedIn) {
        return
    }

    try{
        await loadQuestbackScript('/scripts/questback.popup-1.0.1.min.js')
    }  catch(err) {
        console.info('Questback disabled (blocked/unavailable):', err)
    }

    if (!window.questback?.popup?.create) {
        console.info('Questback disabled (no popup API on window)')
        return
    }

    const questbackConfigOverride = nuxtApp.$config.public.questbackConfig as any;

    const finalConfig = {
        ...questbackPopupConfig,
        ...questbackConfigOverride,
    }

    try {
        console.log("Open questback");
        window.questback.popup.create(QUESTBACK_POPUP_URL, finalConfig);
    } catch(err) {
        console.info('Questback create() failed:', err);
    }
})
